import {
    CARD_TYPE_LABEL_API,
    CARD_TYPE_LABEL_CRM,
    CARD_TYPE_LABEL_MCP,
    CARD_TYPE_LABEL_WEBHOOK,
} from "app/pages/sales-intelligence/modules/manage-integrations/constants/translations";

export const CARD_TYPE = {
    CRM: "CRM",
    Webhook: "Webhook",
    MCP: "MCP",
    API: "API",
} as const;

export type CardType = (typeof CARD_TYPE)[keyof typeof CARD_TYPE];

export const CARD_TYPE_LABEL_KEY: Record<CardType, string> = {
    [CARD_TYPE.CRM]: CARD_TYPE_LABEL_CRM,
    [CARD_TYPE.Webhook]: CARD_TYPE_LABEL_WEBHOOK,
    [CARD_TYPE.MCP]: CARD_TYPE_LABEL_MCP,
    [CARD_TYPE.API]: CARD_TYPE_LABEL_API,
};
